import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import withMemo from '../../decorators/withMemo';
import ForgotPasswordTemplate from '../../templates/ForgotPassword';
import { useHeader, useFooter } from '../../hooks/useAppLayout';
import { generateFieldsProps, getFieldTranslations, compileRules, defineField } from '../../helpers/FormHelpers';
import sagas from './sagas';
import { actions, selectors } from './redux';
var ForgotPassword = function ForgotPassword() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var dispatch = useDispatch();
  var router = useRouter();
  var headerProps = useHeader();
  var footerProps = useFooter();
  var forgotPassword = useSelector(selectors.forgotPassword);
  var message = useSelector(selectors.message);
  var layoutProps = {
    theme: {
      maxWidth: 640
    }
  };
  var pageTitleProps = {
    text: t('forgot_your_password')
  };
  var paragraphProps = {
    text: t('forgot_your_password_text')
  };
  var sections = [{
    type: 'fields',
    content: [defineField({
      name: 'email',
      validation: 'required|email',
      props: {
        type: 'text'
      }
    }), defineField({
      name: 'code',
      validation: 'required',
      props: {
        type: 'text'
      }
    })]
  }];
  var fields = sections.filter(function (section) {
    return section.type === 'fields';
  }).map(function (thisFields) {
    return thisFields.content;
  }).flat();
  var rules = compileRules(fields);
  var formForgottenProps = useMemo(function () {
    return {
      fieldsProps: generateFieldsProps(fields, function (field) {
        var fieldProps = getFieldTranslations(t, "forgotten_form_".concat(field.name));
        return fieldProps;
      }),
      messages: {
        required: t('form_error_required'),
        email: t('form_error_email')
      },
      submitLabel: t('forgotten_form_submit_label'),
      submitPendingLabel: t('form_submit_pending_label'),
      submitSuccessLabel: t('form_submit_success_label'),
      forgottenLinkLabel: t('forgot_your_password'),
      submitPending: forgotPassword.pending,
      submitSuccess: forgotPassword.success,
      backLinkProps: {
        linkProps: {
          onClick: function onClick() {
            return router.back();
          }
        }
      },
      message: message,
      onSubmit: function onSubmit(payload) {
        return dispatch(actions.forgotPassword(payload));
      },
      backLinkLabel: t('back'),
      sections: sections,
      fields: fields,
      rules: rules
    };
  }, [fields, t, forgotPassword.pending, forgotPassword.success, message, sections, rules, router, dispatch]);
  var forgotPasswordTemplateProps = {
    headerProps: headerProps,
    formForgottenProps: formForgottenProps,
    footerProps: footerProps,
    layoutProps: layoutProps,
    pageTitleProps: pageTitleProps,
    paragraphProps: paragraphProps
  };
  return /*#__PURE__*/React.createElement(ForgotPasswordTemplate, forgotPasswordTemplateProps);
};
ForgotPassword.getInitialProps = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", ctx.store.saga.run(sagas.init, ctx).toPromise());
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();
ForgotPassword.propTypes = {};
ForgotPassword.defaultProps = {};
export default withMemo()(ForgotPassword);